import { ChangeEvent, useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Grid, Typography } from '@mui/material';

import { changeSharedVideoFormVideoData } from 'main/store/videos/actions';
import { nanoid } from '@reduxjs/toolkit';

const SUPPORT_TYPE = [
    'video/mpeg',
    'video/mp4',
    'video/quicktime',
    'video/x-msvideo',
    'video/x-ms-wmv'
];

export const VideoFileSelect = () => {
    const [fileName, setFileName] = useState('');
    const [dataURL, setDataURL] = useState('');

    const inputRef = useRef<HTMLInputElement | null>(null);
    const dispatch = useDispatch();

    const handleClick = useCallback(() => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    }, []);

    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files?.length === 1) {
            const file = event.target.files[0];
            setFileName(file.name);

            const reader = new FileReader();
            reader.onload = async () => {
                const dataURL = reader.result as string;
                setDataURL(dataURL);
                dispatch(changeSharedVideoFormVideoData({
                    id: nanoid(),
                    fileName: file.name,
                    base64Data: dataURL.split(',')[1]
                }));
            }
            reader.readAsDataURL(file);
        } else {
            dispatch(changeSharedVideoFormVideoData(null));
        }
    }, [dispatch]);

    return (
        <div>
            <Grid container direction="row" alignItems="center">
                <Button variant="outlined" onClick={handleClick}>
                    動画ファイル選択
                </Button>
                <Typography pl={1}>{fileName}</Typography>
                <input
                    ref={inputRef}
                    type="file"
                    accept={SUPPORT_TYPE.join(',')}
                    style={{ display: 'none' }}
                    onChange={handleChange}
                />
            </Grid>
            {dataURL && <video src={dataURL} />}
        </div>
    )
}
